import { type FetchNftMyCollectiblesV2Params } from '@capsicum/common';

import { nftApi } from '.';

export async function fetchMyCollectibles(params?: FetchNftMyCollectiblesV2Params) {
	return (await nftApi)
		.fetchNftMyCollectiblesV2({
			'statuses[]': ['minted'],
			...params
		})
		.then(res => res.data);
}
